import { render, staticRenderFns } from "./StadiumFieldCreateForm.vue?vue&type=template&id=482dfb26&"
import script from "./StadiumFieldCreateForm.vue?vue&type=script&lang=js&"
export * from "./StadiumFieldCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('482dfb26')) {
      api.createRecord('482dfb26', component.options)
    } else {
      api.reload('482dfb26', component.options)
    }
    module.hot.accept("./StadiumFieldCreateForm.vue?vue&type=template&id=482dfb26&", function () {
      api.rerender('482dfb26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumFieldCreateForm.vue"
export default component.exports